export const PROMOTION_DISCOUNT_TYPE_FLAT_VALUE = 'flat_value'
export const PROMOTION_DISCOUNT_TYPE_PERCENTAGE = 'percentage'

export default {
    flatValue: PROMOTION_DISCOUNT_TYPE_FLAT_VALUE,
    percentage: PROMOTION_DISCOUNT_TYPE_PERCENTAGE,
}
